import {formatText, getTextLength} from "@/utils/util";

export const DEFAULT_CUSTOMER_TAG_LIMIT = 16;

export function getCustomerTagDisplayText(text, limit = DEFAULT_CUSTOMER_TAG_LIMIT) {
  const normalizedText = text ?? '';
  if (getTextLength(normalizedText) > limit) {
    return formatText(normalizedText, limit, true);
  }
  return normalizedText;
}

export function shouldShowCustomerTagTooltip(text, limit = DEFAULT_CUSTOMER_TAG_LIMIT) {
  return getTextLength(text ?? '') > limit;
}
